import React, { useEffect, useCallback, useMemo } from "react";
import styles from "./Reviews.module.scss";

import { ReviewItem } from "./ReviewItem";
import { EmptyContent, Loader, Pagination} from "../../../components";

import {AXIOS} from "../../../services/api";

function Reviews({application = {}}) {
    const [totalPages, setTotalPages] = React.useState(0);
    const [reviews, setReviews] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [error, setError] = React.useState(null);

    const [page, setPage] = React.useState(1);
    const size = 10;
    const reviewsUrl = useMemo(() => `applications/${application.id}/reviews`, [application.id]);

    const fetchReviews = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await AXIOS.get(`${reviewsUrl}?page=${page}&size=${size}`);
            setReviews(response?.data?.data || []);
            setTotalPages(response?.data?.meta?.last_page ?? 0);
        } catch (error) {
            setError('Error fetching reviews');
        } finally {
            setIsLoading(false);
        }
    }, [reviewsUrl, page, size]);

    useEffect(() => {
        fetchReviews();
    }, [fetchReviews]);

    function handlePageChange(page) {
        setPage(page);
    }

    if (isLoading) {
        return <Loader loading={isLoading} />
    }

    if (error) {
        return (
            <div style={{ textAlign: 'center', margin: '2rem 0' }}>
                <div>{error}</div>
                <button onClick={fetchReviews} style={{ marginTop: '1rem' }}>Retry</button>
            </div>
        );
    }

    return (
        <div className={styles.reviewContainer}>
            <div className={styles.reviewSummary}>
                <h2 className={styles.reviewSummaryTitle}>Reviews</h2>
                {/*<div className={styles.ratingSummary}>*/}
                {/*<h3 className={styles.ratingSummaryTitle}>9,305 Reviews</h3>*/}
                {/*<div className={styles.stars}>★★★★★ 5.0</div>*/}
                {/*<div className={styles.barChart}>*/}
                {/*    <div className={`${styles.barChartBar} ${styles.barChartBarFiveStars}`}>9,305 (100%)</div>*/}
                {/*</div>*/}
                {/*</div>*/}
            </div>

            {/*<div className={styles.reviewFilters}>*/}
            {/*    <button className={styles.reviewFilterButton}>All</button>*/}
            {/*    <button className={styles.reviewFilterButton}>Un-Answered</button>*/}
            {/*    <button className={styles.reviewFilterButton}>Responded</button>*/}
            {/*    <button className={styles.reviewFilterButton}>AI Responded</button>*/}
            {/*    <button className={styles.reviewFilterButton}>Auto Responded</button>*/}
            {/*</div>*/}

            {!isLoading && reviews.length === 0 && (
                <EmptyContent message="No reviews available" />
            )}

            <div className={styles.reviewItems}>
                {reviews.map((review) => (
                    <ReviewItem key={review.id} review={review} fetchReviews={fetchReviews} />
                ))}
            </div>

            {
                totalPages > 1 &&
                <div className={styles.pagination} style={{position: 'fixed', bottom: 0, left: 0, right: 0}}>
                    <Pagination currentPage={page} totalPages={totalPages}
                                onPageChange={handlePageChange}/>
                </div>
            }
        </div>
    );
}

export {Reviews};
